export default import.meta.ROLLDOWN_FILE_URL_9laBa9qZvRUo4T73QN$13Q